module.exports = __webpack_public_path__ + "img/益视说明书_16.af0a5128.png";